import { synUtil } from "../../javascript/Utilities";
import "./ErrorDialog.css";

function TdException(error) {
    this.Name = "TdException";
}

(function ($) {
    const fillErrorMessageCore = function (paragraph, error, nesting) {
        let s = paragraph.html();
        const style = nesting > 0 ? " style=\"font-size:85%;\"" : "";
        const div = "<div" + style + ">" + kendo.htmlEncode(error.ErrorDisplayMessage).replace(/\r?\n/g, "<br/>") + "</div>";
        s += div;
        paragraph.html(s);
        if (error.InnerError)
            fillErrorMessageCore(paragraph, error.InnerError, nesting + 1);
    };

    // fill error DisplayMessage for error and child errors
    const fillErrorMessage = function (error) {
        fillErrorMessageCore($("#errorMsg_" + error.Id), error, 0);

        const errorDate = error.ThrowTime || synUtil.dateTimeToJson(new Date());
        $("#errorMsg_" + error.Id).append('<div class ="errorDialogTimestamp">' + dateToString(errorDate) + '</div>');
    };

    const fillErrorDetailsCore = function (textarea, error) {
        for (const key in error) {
            if (error.hasOwnProperty(key)) {
                if (key === "InnerError") {
                    if (error[key]) {
                        textarea.val(textarea.val() + '\n\nINNER ERROR:');
                        fillErrorDetailsCore(textarea, error[key]);
                    }
                } else if (key === "ThrowTime") {
                    const line = key + ": " + dateToString(error[key] || undefined);
                    textarea.val(textarea.val() + '\n' + line);
                } else if (key === "Id" || key === "ie7") {
                    continue;
                } else {
                    const lline = key + ": " + error[key];
                    textarea.val(textarea.val() + '\n' + lline);
                }

            }
        }
    };

    // fill error details for error and child errors
    const fillErrorDetails = function (error) {
        fillErrorDetailsCore($("#errorDetails_" + error.Id), error);
    };

    const dateToString = function (dateString) {
        let date = +new Date();
        if (dateString) {
            const MIN_DATE = -62135578800000;
            const date2 = synUtil.jsonToDateTime(dateString);
            if (date.toString() !== new Date(MIN_DATE).toString())
                date = date2;
        }
        return kendo.toString(date, "G");
    };
    const padStr = function (i) {
        return (i < 10) ? "0" + i : "" + i;
    };
    const padStrMillis = function (i) {
        let s = "" + i;
        if (i < 100)
            s = "0" + s;
        if (i < 10)
            s = "0" + s;
        return s;
    };


    // data for the currenly open error dialog
    let errorDlgData;

    const methods =
    {
        show: function (error, options) {
            const errorContentMarkup = require("../../templates/ErrorPanel.tmpl.html");

            // Todo: What if several Errors occur because n>1 controls make requests and all of them fail?
            // Possible solutions:
            // 1.) Display only the first error (currently implemented but this may suppress important errors!)
            // 2.) create some "work" id clientside and let the webservices return this ID in the errors,
            //     display only one error per work id.+
            // 3.) Enhance the error dialog to support several errors (appending errors to the open dialog)
            if (error != undefined && !errorDlgData) {
                const guid = synUtil.getGUID(true);
                const divId = 'error_' + guid;

                // Div for the window itself
                const windowDiv = $("<div id='" + divId + "' />").appendTo(document.body);

                //Div for the content inside the window
                const errorDiv = windowDiv.append('<div class="errorContainer" id="content_' + divId + '" />');

                const template = kendo.template(errorContentMarkup);

                // Add the control GUID to the error structure
                error.Id = guid;

                // Add reference to synUtil
                error.synUtil = synUtil;

                // Create HTML from template
                $("#" + divId).html(template(error));

                const wnd = windowDiv.kendoWindow({
                    iframe: false,
                    title: "syneris Information",
                    resizable: false,
                    modal: ($("div.k-overlay").length === 0),
                    animation: false,
                    deactivate: function (e) {
                        this.destroy();
                        errorDlgData = undefined;
                    }
                });
                if (!error.ErrorDisplayMessage)
                    error.ErrorDisplayMessage = error.message;

                $("#expandCollapseButton_" + error.Id).on("click", function () {
                    $.errorDialog("toggle_details");
                });

                $("#okButton_" + error.Id).on("click", function () {
                    $.errorDialog("hide");
                });

                fillErrorMessage(error);
                fillErrorDetails(error);
                wnd.data("kendoWindow").center().open();

                $("#okButton_" + guid).focus();

                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();

                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                errorDlgData = {
                    div: errorDiv,
                    window: wnd
                };
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                if (options && options["initiallyexpanded"]) {
                    $.errorDialog("toggle_details");
                    // re-center because window is initally expanded
                    wnd.data("kendoWindow").center();
                }
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();

                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();
                wnd.data("kendoWindow").center();

            }
        },
        toggle_details: function () {
            if (errorDlgData && errorDlgData.div) {

                const detailspanel = errorDlgData.div.find(".errorDialogDetailsPanel");
                const expandCollapse = errorDlgData.div.find(".expandCollapseButton");

                if (detailspanel.css("display") === "none") {
                    detailspanel.css("display", "block");
                    expandCollapse.prop("value", "<< " + synUtil.Strings.getValue("less", "Less"));
                } else {
                    detailspanel.css("display", "none");
                    expandCollapse.prop("value", ">> " + synUtil.Strings.getValue("more", "More"));
                }
            }
        },
        hide: function () {
            if (errorDlgData && errorDlgData.window)
                errorDlgData.window.data("kendoWindow").close();
        }
    };

    // TODO:
    // Cover the following cases for error:
    // * Error JSON (done)
    // * passing jqXHR (if request fails due to some network related error such that even the proxy can't be reached)
    // * javascript exceptions
    // * (optionally XML error representation)
    $.errorDialog = function (method, options) {

        const settings = $.extend({
            'initiallyexpanded': false
        }, options);

        if (methods[method])
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        else if (typeof method === 'object' || !method)
            return methods.show.apply(this, arguments);
        else
            $.error('Method ' + method + ' does not exist on jQuery.errorDialog');
    };

})(jQuery);
